<script lang="ts">
  import Anchor from "src/partials/Anchor.svelte"
</script>

<div class="z-10 relative -mt-4 mb-0 flex justify-center">
  <Anchor stopPropagation button low on:click>See more</Anchor>
</div>
